<div class="msin-background"></div>

<mat-card appearance="outlined" class="login-page">
	<mat-card-header>
		<mat-card-title>
			<a routerLink="/login">
				<img class="login-logo" alt="MSIN Logo"
					src="../../../../assets/images/MSIN-Logo_Color-White-Text.png" />
			</a>
		</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		<mat-card appearance="outlined">

			<mat-card-header>
				<mat-card-title>New MSIN Account Creation</mat-card-title>

			</mat-card-header>
			<mat-card-content>

				<h3 *ngIf="isConfirming" class="text-center">
					<mat-icon>
						<mat-spinner diameter="20"> </mat-spinner>
					</mat-icon>
					Confirming Confirmation Code
				</h3>

				<h3 *ngIf="!confirmed && !confirmMsg.SUCCESS && !isConfirming && !isLoading">
					<app-msg [msg]="confirmMsg"></app-msg>
				</h3>

				<form *ngIf="confirmed && !isConfirming" [formGroup]="form" (submit)="changePassword()"
					class="d-flex flex-column">
					<div class="row">

						<div class="col-lg-12 margin-bottom-sm">
							<input-username [form]="form" [controlName]="'username'" [matLabel]="'Username'"
								[placeholder]="'Username'"></input-username>
						</div>

						<div class="col-lg-12 margin-bottom-sm">
							<input-password [form]="form" [controlName]="'password'" [matLabel]="'New Password'"
								[placeholder]="'New Password'" [(passwordToConfirm)]="passwordToConfirm">
							</input-password>
						</div>

						<div class="col-lg-12">
							<input-password-confirm [form]="form" [controlName]="'confirmPassword'"
								[targetControlName]="'password'" [matLabel]="'Confirm New Password'"
								[placeholder]="'Confirm New Password'" [passwordToConfirm]="passwordToConfirm">
							</input-password-confirm>
						</div>

						<div class="col-lg-12">
							<button class="w-100" type="submit" mat-raised-button color="primary"
								[disabled]="!form.valid || isLoading || changed">

								<mat-icon *ngIf="isLoading && !msg.SUCCESS">
									<mat-spinner *ngIf="isLoading" diameter="20"> </mat-spinner>
								</mat-icon>
								<mat-icon *ngIf="msg.SUCCESS">
									done
								</mat-icon>
								Create
							</button>
						</div>

						<div class="row">
							<div class="col">
								<app-msg [msg]="msg"></app-msg>
							</div>
						</div>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
		<mat-card appearance="outlined" class="margin-top-sm">
			<a mat-raised-button routerLink="/login">Back to Login</a>
		</mat-card>
	</mat-card-content>
</mat-card>